export default function share ($el) {
  $el.addEventListener('click', handleClick.bind($el))
}

function handleClick (e) {
  e.preventDefault()
  const href = this.href
  const left = window.screen.width / 2 - 600 / 2
  const top = window.screen.height / 2 - 440 / 2

  window.open(
    href,
    '',
    `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=600,height=440,top=${top},left=${left}`
  )
}



// WEBPACK FOOTER //
// ./src/js/ui/share.js